import script from "./m-inner-header.vue?vue&type=script&setup=true&lang=js"
export * from "./m-inner-header.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__